<section class="search-wrapper">
  <!-- Search Bar -->
  <div class="search-bar mt-3">
    <!-- input search -->
    <div class="row search-menu">
      <div class="col-6">
        <form action="javascript:;">
          <div class="page-search-input form-group position-relative">
            <input type="search" class="form-control rounded-right form-control-lg shadow pl-2" [(ngModel)]='term'
              name="term" placeholder="Search Anything..." (keyup.enter)="searchCollections()">
          </div>
        </form>
      </div>
      <div class="col-6">
        <form action="javascript:;">
          <div class="page-search-input form-group position-relative">
            <input type="search" class="form-control rounded-right form-control-lg shadow pl-2" name="modelFormat"
              id="searchbar" placeholder="Add tags to search" [formControl]="searchTerm" [matAutocomplete]="auto">
            <mat-autocomplete #auto="matAutocomplete">
              <mat-option *ngFor="let tag of searches | slice: 0:5" (onSelectionChange)="selectSearchedOption(tag)">
                {{tag.name}}
              </mat-option>
            </mat-autocomplete>
            <button *ngIf="selectedTags?.length || term" (click)='resetTag()'
              class="btn btn-primary search-btn rounded position-absolute" type="button">
              <span class="d-none d-sm-block">Reset</span>
              <i class="ft-search d-block d-sm-none"></i>
            </button>
            <button class="btn btn-primary search-btn rounded position-absolute" type="button"
              (click)="searchCollections()">
              <span class="d-none d-sm-block">Search</span>
              <i class="ft-search d-block d-sm-none"></i>
            </button>
          </div>
        </form>
      </div>
    </div>
    <!--/ input search -->
  </div>
  <div class="row search-menu" *ngIf="selectedTags?.length || this.searchesCollection.rb_collections.length">
    <div class="col-12">
      <!-- search menu tab -->
      <mat-chip-list #chipList aria-label="Fruit selection">
        <mat-chip *ngFor="let tag of selectedTags">
          {{tag.name}}
          <button type="button" class="close ml-1" aria-label="Close" (click)="selectSearchedOption(tag)">
            <span aria-hidden="true">&times;</span>
          </button>
        </mat-chip>
        <mat-chip color="primary" selected (click)='resetTag()'>
          Reset
        </mat-chip>
      </mat-chip-list>
    </div>
    <!-- <div class="col-12">
        <div class="search-speed mb-1 mt-4">
          <small class="text-muted">About 133,000,000 results (0.45seconds)</small>
        </div>
      </div> -->
  </div>

  <app-collection *ngIf="this.searchesCollection.rb_collections.length" [rows]="searchesCollection" [term]="term">
  </app-collection>

  <div class="kb-content" *ngIf="!this.searchesCollection.rb_collections.length">
    <div class="row kb-content-info match-height">
      <div class="col-md-4 col-sm-6 kb-content-card" *ngFor="let tag of rows">
        <div class="card" (click)="selectTag(tag)">
          <div class="card-content">
            <div class="card-body text-center p-4">
              <a>
                <h5 class="mt-2">{{tag.name}}</h5>
                <p class="m-0 text-muted">{{tag.description}}</p>
              </a>
            </div>
          </div>
        </div>
      </div>
      <div class="col-12 kb-no-content" *ngIf="!rows?.length">
        <div class="card bg-transparent shadow-none">
          <div class="card-content">
            <div class="card-body text-center">
              <p class="m-0 d-flex justify-content-center align-items-center">
                <i class="ft-alert-circle font-medium-2 mr-1"></i>
                <span>No result found</span>
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- <div class="d-flex p-2 justify-content-center  ">
      <ngb-pagination [collectionSize]="count" [pageSize]="pageSize" [(page)]="currentPage" [rotate]="true"
        (pageChange)="pageChange(currentPage)" [boundaryLinks]="true" [ellipses]="true">
      </ngb-pagination>
    </div> -->
  </div>
</section>